import { Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useState } from 'react';

import { OrderItem } from './';

const OrderList = ({ handleChange, orderItems, price }) => {
  const [visible, setVisible] = useState(true);

  if (!orderItems?.length) return null;

  return (
    <Col wid="100%">
      <Row marg="24px 0 0" between center>
        <Text>
          {orderItems.length} orders - ${price.toFixed(2)}
        </Text>

        <Clickable onClick={() => setVisible(!visible)}>
          <Row centerAll gap="16px" pad="0 16px 8px" borderBottom={`2px solid ${theme.GREY_20}`}>
            <Text>{visible ? 'Hide' : 'Show'}</Text>

            <Icon type={!visible ? 'down' : 'up'} dimensions={15} col={theme.GREY_60} />
          </Row>
        </Clickable>
      </Row>

      {visible &&
        orderItems.map((orderItem) => (
          <OrderItem item={orderItem} handleChange={(opt) => handleChange(orderItem, opt)} />
        ))}
    </Col>
  );
};

export default OrderList;
